<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
           <template>
             <b-overlay :show="loading">
                <b-row>
                  <b-col lg="12" sm="12">
                    <b-table-simple striped bordered small fixed>
                      <b-tr>
                        <b-th>{{ $t('fair_evaluation.criterial_name')}}</b-th>
                        <b-td>{{ ($i18n.locale === 'bn') ? data.criteria_name_bn : data.criteria_name }}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-th>{{ $t('fair_evaluation.marking_type')}}</b-th>
                        <b-td>{{ getRelationalData(data.marking_type) }}</b-td>
                      </b-tr>
                      <b-tr v-if="data.marking_type === 1">
                        <b-th>{{ $t('fair_evaluation.description')}}</b-th>
                        <b-td>{{ ($i18n.locale === 'bn') ? data.description_bn : data.description }}</b-td>
                      </b-tr>
                      <b-tr v-if="data.marking_type === 2">
                        <b-th>{{ $t('fair_evaluation.maximum_percentage')}}</b-th>
                        <b-td>{{ data.max_percentage }}</b-td>
                      </b-tr>
                      <b-tr v-if="data.marking_type === 2">
                        <b-th>{{ $t('fair_evaluation.minimum_percentage')}}</b-th>
                        <b-td>{{ data.min_percentage }}</b-td>
                      </b-tr>
                      <b-tr v-if="data.marking_type === 3">
                        <b-th>{{ $t('fair_evaluation.maximum_mark')}}</b-th>
                        <b-td>{{ data.max_mark }}</b-td>
                      </b-tr>
                      <b-tr v-if="data.marking_type === 3">
                        <b-th>{{ $t('fair_evaluation.minimum_mark')}}</b-th>
                        <b-td>{{ data.min_mark }}</b-td>
                      </b-tr>
                    </b-table-simple>
                  </b-col>
                </b-row>
              </b-overlay>
            </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '../../../../../config/pluginInit'
import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
import { fairEvaluationShowApi } from '../../api/routes'

export default {
    name: 'FormLayout',
    props: ['id', 'item'],
    components: {
    },
    created () {
      if (this.id) {
          this.data = this.getData()
      }
    },
    mounted () {
        core.index()
    },
    computed: {
         markingType: function () {
            const objectData = this.$store.state.AwarenessEventService.commonObj.markingTypeList
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        loading () {
          return this.$store.state.commonObj.loading
        }
    },
    data () {
        return {
            ItemShow: false,
            saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            data: {}
        }
    },
    methods: {
        async getData () {
          this.$store.dispatch('mutateCommonProperties', { loading: true })
            if (this.id) {
               await RestApi.getData(awarenessEventServiceBaseUrl, `${fairEvaluationShowApi}/${this.id}`).then(response => {
                    if (response.success) {
                        this.data = response.data
                    }
                    this.$store.dispatch('mutateCommonProperties', { loading: false })
                })
            }
        },
        getServiceName (id) {
            const objectData = this.$store.state.AwarenessEventService.commonObj.serviceTypeList.find(item => item.value === parseInt(id))
                return objectData.value
        },
         getRelationalData (id) {
            const List = this.$store.state.AwarenessEventService.commonObj.markingTypeList.find(service => service.value === parseInt(id))
             if (List !== undefined) {
               if (this.$i18n.locale === 'bn') {
                    return List.text_bn
                } else {
                    return List.text_en
                }
             }
          }
     }
}
</script>
